module.exports = __webpack_public_path__ + "static/media/tats-logo.d5e1bc38.png";